import request from "../request";

export function getFollowList(params) {
  return request({ url: "/market-service/scrm/follow/list", method: "GET", params });
}

export function addFollow(data) {
  return request({ url: "/market-service/scrm/follow/add", method: "POST", data });
}
export function addFollowReply(data) {
  return request({ url: "/market-service/scrm/follow/addReply", method: "POST", data });
}